// ©2024 Austin App House. All rights reserved.
import React from 'react';

const DeviceQty = ({ value = 0, handler }) => (
  <div className="field_row">
  <div className="field_name">
    <label htmlFor="qryDevices">
      Qty Devices:
    </label>
  </div>
      <div className="field_block">
    <input
      id="qryDevices"
      type="number"
      value={value}
      onChange={(event) => handler(event.target.value)}
    />
      </div>
  </div>
);

export default DeviceQty;
